<style>
    .controlled-image__container {
        display: inline-block;
        position: relative;
    }

    .controlled-image {
        display: block;
    }

    .controlled-image[data-rounded] {
        border-radius: 4px;
    }

    .controlled-image[data-circular] {
        border-radius: 50%;
    }

    .controlled-image[data-border] {
        border: 1px solid #EEE;
    }

    .controlled-image[data-border-red] {
        border: 1px solid red;
    }

    .controlled-image[data-border-orange] {
        border: 1px solid #ff4814;
    }

    .controlled-image__slot {
        position: absolute;
    }

    .controlled-image__slot--bottom-left {
        left: -2px;
        bottom: -8px;
    }

    .controlled-image__slot--bottom-left-circle {
        left: 25px;
        bottom: 5px;

    }

    @media screen and (max-width: 768px) {
        .controlled-image__slot--bottom-left-circle {
            left: 5px;
            bottom: 0px;
        }
    }
</style>

<template>
    <span class="controlled-image__container" :style="{verticalAlign: align}">
        <img class="controlled-image" :src="src" :alt="alt" :data-rounded="rounded" :data-circular="circular" :width="width" :data-border="border" :data-border-red="borderRed" :data-border-orange="borderOrange" />
        <span v-if="$slots['bottom-left']" class="controlled-image__slot controlled-image__slot--bottom-left">
            <slot name="bottom-left" />
        </span>
        <span v-if="$slots['bottom-left-circle']" class="controlled-image__slot controlled-image__slot--bottom-left-circle">
            <slot name="bottom-left-circle" />
        </span>
    </span>
</template>

<script>
    export default {
        props: {
            src: String,
            alt: {type: String, default: ''},
            width: String,
            rounded: Boolean,
            circular: Boolean,
            align: {type: String, default: 'middle'},
            border: Boolean,
            borderRed: Boolean,
            borderOrange: Boolean,
        }
    };
</script>
